module.exports = __webpack_public_path__ + "static/media/tape.b638ec15.png";